/**
 * Created by Shiv Roy on 21/12/17.
 */

import { actionCreator, checkHttpStatus, createSearchUrl, createSearchUrlForCustomAPI, createSearchUrlScheduling, downloadFilesOnAPICallForCCDA, extractDataFromObject, GET_APPOINTMENT_DATA_API,
  GET_OFFICE_HOURS_API, GET_PATIENT_INSURANCE_API,
  jsonApiHeader,
  PATIENT_ALLERGY_API,
  PATIENT_APPOINTMENT_API,
  PATIENT_AUTHORIZATION_API,
  PATIENT_DETAIL,
  PATIENT_ENCOUNTER_API,
  PATIENT_FAMILY_HISTORY_API,
  PATIENT_IMMUNIZATION_API,
  PATIENT_LABS_API,
  PATIENT_MEDICATION_API,
  PATIENT_NONBILLABLE_ENCOUNTERS_DETAILS_API,
  patientActionTypes,
  POST_ENCOUNTER_SIGNS_API,
  SAVE_SOAP_API,
  showFormatedDate,
  showSuccessMessage,
  Claim_API,
} from './../constants/ApiConstants';
import { API_URL, checkHttpStatusAuthCheck } from '../../../../../actions/utilAction';
import { showErrorMessage } from '../../../../scheduling/components/soap/constants/ApiConstants';
import Alert from 'react-s-alert';

export { extractDataFromObject, showFormatedDate };

export const getPatientDetails = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_details.REQUEST));
    fetch(`${PATIENT_DETAIL}?id=${patientId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patient_details.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

// get patient immunization ...
export const getPatientImmunizationList = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_immunization.REQUEST));
    fetch(`${PATIENT_IMMUNIZATION_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patient_immunization.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patient_immunization.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('get Patient Immunization Action error', error);
      });
  };
};

// get patient medications ...
export const getPatientMedicationList = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_medication.REQUEST));
    fetch(`${PATIENT_MEDICATION_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patient_medication.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patient_medication.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('get Patient Medication Action error', error);
      });

  };
};

// get patient lab orders
export const getPatientLabsList = (searchObj) => {
  let query_params = createSearchUrl(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_labs.REQUEST));
    fetch(`${PATIENT_LABS_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patient_labs.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get Patient labs Action error', error);
      });
  };
};

// get appointments for a particular patient ...
export const getPatientAppointmentList = (searchObj) => {
  let query_params = createSearchUrlScheduling(searchObj);
  // console.log(`${GET_APPOINTMENT_API}${query_params}`);
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_appointment.REQUEST));
    fetch(`${PATIENT_APPOINTMENT_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        dispatch(actionCreator(patientActionTypes.get_patient_appointment.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get Patient appointments Action error', error);
      });
  };
};

// get patient allergies ...
export const getPatientAllergiesList = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_allergy.REQUEST));
    fetch(`${PATIENT_ALLERGY_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patient_allergy.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patient_allergy.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('get Patient allergies Action error', error);
      });
  };
};

// get patient insurances ...
export const getPatientInsuranceList = (patientId) => {
  let query_params = `?patientId=${patientId}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_insurance.REQUEST));
    fetch(`${GET_PATIENT_INSURANCE_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patient_insurance.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patient_insurance.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('get Patient insurances Action error', error);
      });
  };
};

// get patient authorization by patient id ...
export const getPatientAuthorizationList = (searchObj) => {
  let query_params = `?patientId=${searchObj.patientId}&pageNumber=${searchObj.page_number}&pageSize=${searchObj.pageSize}&authType=${searchObj.authType}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_authorization.REQUEST));
    fetch(`${PATIENT_AUTHORIZATION_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patient_authorization.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get Patient authorizations Action error', error);
      });
  };
};

// get patient family history ...
export const getPatientFamilyHistoryList = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_family_history.REQUEST));
    fetch(`${PATIENT_FAMILY_HISTORY_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patient_family_history.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get Patient family history Action error', error);
      });
  };
};

// get office hours of location(s) in schedulling ..
export const getOfficeHours = (locationIds) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_office_hours.REQUEST));
    fetch(`${GET_OFFICE_HOURS_API}?locationIds=${locationIds}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_office_hours.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_office_hours.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('get Patient schedulling office hours Action error', error);
      });
  };
};

// get patient Single Encounters Detail...
export const getPatientSingleEncounter = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_single_encounter.REQUEST));
    fetch(`${PATIENT_ENCOUNTER_API}/${searchObj.apptId}/${searchObj.encounterId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response.......',response);
        dispatch(actionCreator(patientActionTypes.get_patient_single_encounter.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get Patient encounter Action error', error);
      });
  };
};

// save patient sign in patient encounter ...
export const savePatientEncounter = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patient_soap.REQUEST));
    let requestType = 'post';
    let fetchAPI = `${SAVE_SOAP_API}`;

    fetch(fetchAPI, {
      method: requestType,
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.post_patient_soap.SUCCESS, response));
        let successMsg = response.message;
        showSuccessMessage(successMsg);
        let searchObj = {
          apptId: formData.PatientAppointmentId,
          encounterId: response.data.id,
        };
        dispatch(getPatientSingleEncounter(searchObj));
      })
      .catch(function(error) {
        console.log('save Patient encounter Action error', error);
      });
  };

};

// Video call
export const getAppointmentById = (appointment_id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_appointment_by_id.REQUEST));
    fetch(`${GET_APPOINTMENT_DATA_API}?appointmentId=${appointment_id}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_appointment_by_id.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get appointment_by_id error', error);
      });

  };
};

export const ExportCCDA = (patientID) => {
  return (dispatch, getState) => {
    // window.open(`${API_URL}/patient/GetPatientCCDA/${patientID}`, '_blank');

    let apiURL = `${API_URL}/patients/GetPatientCCDA?id=${patientID}`;
    fetch(apiURL, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/xml'),
    })
      .then((r) => r.blob())
      .then(downloadFilesOnAPICallForCCDA) // showPDF
      .then();
  };
};

export const getPatientEncounterNonBillable = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_encounter_nonBillable.REQUEST));
    fetch(`${PATIENT_NONBILLABLE_ENCOUNTERS_DETAILS_API}/${searchObj.apptId}/${searchObj.encounterId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patient_encounter_nonBillable.SUCCESS, response));
      })
      .catch(function(error) {
        // dispatch(actionCreator(soapActionTypes.get_patient_soap.FAILURE));
        console.log('get_patient_encounter error', error);
      });
  };
};


export const saveEncounterSigns = (postData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_EncounterSigns.REQUEST));
    fetch(POST_ENCOUNTER_SIGNS_API, {
      method: 'POST',
      body: JSON.stringify(postData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_EncounterSigns.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_EncounterSigns.SUCCESS, null));
        }
      })
      .catch((error) => {
        console.log('error saveEncounterSigns', error);
      });
  };
};

export const createClaimAction = (enc_id, isAdmin = false) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.create_claim.REQUEST));
    // console.log(`${Claim_API}?patientEncounterId=${enc_id}`);
    fetch(`${Claim_API}?patientEncounterId=${enc_id}&isAdmin=${isAdmin}`, {
      method: 'post',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log(response);
        Alert.closeAll();
        dispatch(actionCreator(patientActionTypes.create_claim.SUCCESS));
        if (response.statusCode === 1) {
          let successMsg = response.message;
          showSuccessMessage(successMsg);
        } else {
          let errorMsg = response.message;
          showErrorMessage(errorMsg);
        }
        // console.log(response);
      })
      .catch(function(error) {
        dispatch(actionCreator(patientActionTypes.create_claim.FAILURE));
        console.log('get_patient_soap--- create claim error', error);
      });
  };
};


// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/details/actions/index.js